import { useEffect, useRef, useState } from "react";
import { parseSRT } from "../helpers/parseSRT";


export function useAudioSubtitles(audioUrl, srtUrl, options = {}) {
  const audioRef = useRef(null);
  const [subtitles, setSubtitles] = useState([]);
  const [currentSubtitle, setCurrentSubtitle] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  // Charger & parser les sous-titres
  useEffect(() => {
    if (!srtUrl) return;
    fetch(srtUrl)
    .then((res) => res.text())
    .then((srtText) => {
      const parsed = parseSRT(srtText);
      setSubtitles(parsed);
    });
  }, [srtUrl]);

  // Suivi du temps
  useEffect(() => {
    const interval = setInterval(() => {
      const audio = audioRef.current;
      if (!audio) return;

      setCurrentTime(audio.currentTime);
      setIsPlaying(!audio.paused);

      const current = subtitles.find(
        ({ start, end }) =>
          currentTime * 1000 >= start && currentTime * 1000 <= end
      );

      setCurrentSubtitle(current?.text ?? "");
    }, 100);

    return () => clearInterval(interval);
  }, [subtitles, currentTime]);

  // Préchargement de l'audio
  useEffect(() => {
    const audio = audioRef.current;
    if (options.autoplay && audio) {
      audio.muted = true;
  
      audio.play()
        .then(() => {
          // tu peux attendre une interaction pour remettre le son ici
        })
        .catch((error) => {
          console.warn("Lecture audio bloquée, en attente d'interaction.");
          // attend un clic utilisateur
          const handleUserGesture = () => {
            audio.muted = false;
            audio.play().catch(() => {});
            window.removeEventListener("click", handleUserGesture);
          };
          window.addEventListener("click", handleUserGesture);
        });
    }
  }, [audioUrl, options.autoplay]);
  

  return {
    audioRef,
    currentSubtitle,
    currentTime,
    isPlaying,
  };
}
